import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { CreateCompanyForm } from '@/components/companies/CreateCompanyForm'
import { EditCompanyForm } from '@/components/companies/EditCompanyForm'
import type { Company } from '@/hooks/useCompanies'

interface CompanyFormModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  mode: 'create' | 'edit'
  company?: Company
  onSuccess?: () => void
}

export function CompanyFormModal({
  open,
  onOpenChange,
  mode,
  company,
  onSuccess,
}: CompanyFormModalProps) {
  const handleSuccess = () => {
    onOpenChange(false)
    onSuccess?.()
  }

  const handleCancel = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto bg-background">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">
            {mode === 'create' ? 'Create New Company' : 'Edit Company'}
          </DialogTitle>
          <DialogDescription>
            {mode === 'create'
              ? 'Add a new company to the platform and create its admin account'
              : 'Update company information and settings'}
          </DialogDescription>
        </DialogHeader>

        {mode === 'create' ? (
          <CreateCompanyForm onSuccess={handleSuccess} onCancel={handleCancel} />
        ) : company ? (
          <EditCompanyForm company={company} onSuccess={handleSuccess} onCancel={handleCancel} />
        ) : null}
      </DialogContent>
    </Dialog>
  )
}
